<template>
  <div id="app">
    <div id="app-header">
      <BANotify-Level4-header v-if="$route.name && $route.meta && $route.meta.header != 'none'" />
      <header-frame
        v-if="$route.name && $route.meta && $route.meta.header != 'none'"
        ref="headerframe"
        @dialogVisitorFastLeave="dialogVisitorFastLeave"
        @dialogVisitor="dialogVisitorSwitch"
        @openGuestDialog="openGuestDialog"
        @faseActive="faseActive"
        @showOpenCodeDialog="isOpenCodeDialog = true"
        @managerQRCode="openManagerQRCode"
      />
    </div>
    <dialog-visitor
      ref="dialogVisitor"
      @updateHeaderCount="updateHeaderframeCount"
    />
    <guest-dialog ref="GuestDialog" />
    <fast-active
      ref="FastActive"
      @updateHeaderCount="updateHeaderframeCount"
    />
    <template v-if="$route.name && $route.meta && $route.meta.header != 'none'">
      <float-icon-new-feature />
      <fast-receive @updateHeaderCount="updateHeaderframeCount" />
      <FAQ />
      <ActionSupport />
    </template>
    <router-view />
    <footer-frame v-if="$route.name && $route.meta && $route.meta.footer != 'none'" />
    <bottom-right-area v-if="$route.name && $route.meta && $route.meta.logoutinfo != 'none'" />
    <notify-layout v-if="$route.name && $route.meta && $route.meta.logoutinfo != 'none'" />
    <guest-info-frame v-if="$route.name && $route.meta && $route.meta.logoutinfo != 'none'" />
    <register-sw ref="registerSwMain" />
    <BANotify-Level4-fullScreen v-if="$route.name && $route.meta && $route.meta.header != 'none'" />
    <community-open-dialog
      v-model="isOpenCodeDialog"
      :is-show-cancel-alert="false"
      :is-re-login-alert="true"
    />
    <el-dialog
      id="managerQRCodeDialog"
      class="qr-dialog"
      :visible.sync="isShowManagerQRCode"
      @close="closeManagerQRCodeDialog"
    >
      <div slot="title">
        <p class="dialog-title">
          管理員識別碼
        </p>
      </div>
      <div class="qrcode-modal-container">
        <p id="communityName">
          {{ loginUserInfo.CommunityName }}
        </p>
        <p id="userName">
          {{ loginUserInfo.AdminName }}
        </p>
        <div id="qrcode">
          <vue-qr
            :correct-level="0"
            :text="managerQRCodeToken"
            :size="140"
            :margin="0"
            :color-dark="timerSecond < 0 ? '#00000020' : '#000000'"
            :color-light="'#ffffff'"
          />
          <button
            v-if="timerSecond < 0"
            class="reload-btn"
          >
            <i
              class="icon-refresh reload"
              @click="openManagerQRCode()"
            />
          </button>
        </div>
        <div id="timer">
          <template v-if="timerSecond >= 0">
            0{{ Math.floor(timerSecond/60) }}:{{ (timerSecond%60).toString().padStart(2, '0') }}
          </template>
          <span
            v-else
            class="qrcode-timeout-hint"
          >
            QR Code 已失效，請點擊條碼重新產生
          </span>
        </div>
      </div>
    </el-dialog>
    <version-update-notify />
  </div>
</template>
<script>
import dialogVisitor from '@/components/DialogVisitor'
import FastActive from '@/components/FastActive'
import FastReceive from '@/components/FastReceive'
import FAQ from '@/components/FloatIcons/FAQ'
import ActionSupport from '@/components/FloatIcons/ActionSupport'
import HeaderFrame from '@/components/HeaderFrame'
import FooterFrame from '@/components/FooterFrame'
import RegisterSwFrame from '@/components/RegisterSwFrame'
import BottomRightArea from '@/components/BottomRightArea'
import GuestInfoFrame from '@/components/Notify/GuestInfoFrame'
import FloatIconNewFeature from '@/components/FloatIcons/NewFeature'
import GuestDialog from '@/components/GuestDialog'
import versionUpdateNotify from '@/components/Notify/versionUpdateNotify'
import NotifyLayout from '@/components/Notify/NotifyLayout'
import BANotify_Level4_header from '@/components/Notify/BANotify_Level4/header'
import BANotify_Level4_fullScreen from '@/components/Notify/BANotify_Level4/fullScreen'
import CommunityOpenDialog from '@/components/CommunityOpenDialog'
export default {
  components: {
    'dialog-visitor': dialogVisitor,
    'fast-active': FastActive,
    'header-frame': HeaderFrame,
    'footer-frame': FooterFrame,
    'register-sw': RegisterSwFrame,
    'bottom-right-area': BottomRightArea,
    'guest-info-frame': GuestInfoFrame,
    'fast-receive': FastReceive,
    FAQ,
    ActionSupport,
    'float-icon-new-feature': FloatIconNewFeature,
    'guest-dialog': GuestDialog,
    'version-update-notify': versionUpdateNotify,
    'notify-layout': NotifyLayout,
    'BANotify-Level4-header': BANotify_Level4_header,
    'BANotify-Level4-fullScreen': BANotify_Level4_fullScreen,
    'community-open-dialog': CommunityOpenDialog
  },
  data () {
    return {
      isOpenCodeDialog: false,
      isShowManagerQRCode: false,
      openCode: '',
      authorization: null,
      loginUserInfo: {},
      qrcodeTimer: null,
      timerSecond: 5 * 60,
      managerQRCodeToken: '',
      isSendingOpenCode: false // 開通序號是否送出中
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        window.scrollTo(0, 0)
        const language = (
          navigator.language || navigator.browserLanguage
        )
        const locales = Object.keys(this.$i18n.messages)
        for (const locale of locales) {
          if (language.indexOf(locale) > -1) {
            this.$store.dispatch('changeLanguage', locale)
            this.$i18n.locale = locale
            break
          }
        }
        this.$nextTick(() => {
          this.updateHeaderframeCount()
          if (
            window.location.href.indexOf('visitorRealNameRigistration') > -1 ||
            window.location.href.indexOf('supplierMaintenance') > -1 ||
            window.location.href.indexOf('visitorRealNameSuccess') > -1 ||
            window.location.href.indexOf('lastLoginInformation') > -1 ||
            window.location.href.indexOf('assetQRcode') > -1
          ) {
            // 無需權限
            return false
          }
          if (!(window.location.href.indexOf('login') > -1)) {
            this.$refs.registerSwMain.checkPermission()
          }
        })

        // 取得當前定位．雖然管理版Web目前沒有任何功能是強需定位
        // 但比照Housekeeper及舊規則，仍請求位置資訊
        this.getGeolocation()
          .then(coords => {
            this.$store.commit('setGeolocation', coords)
          })
          .catch(error => {
            this.$store.commit('setGeolocation', {
              latitude: 0,
              longitude: 0
            })
            console.error('定位失敗：', error)
          })
      }
    }
  },
  created () {
    this.checkHttps(['kingnetsmart.com.tw'])
    vuecp.app = this
    this.pushNotify()
  },
  mounted () {
    window.addEventListener('storage', this.handleStorage)
  },
  destroyed () {
    window.removeEventListener('storage', this.handleStorage)
  },
  methods: {
    checkHttps (httpsArr, httpArr) { // 檢查https
      function getUrl () {
        return window.location.href
      }
      function haveHttps (url) {
        return url.indexOf('https://') > -1
      }
      httpArr = httpArr || []
      httpsArr = httpsArr || []
      const targetUrl = getUrl()
      const isHttps = haveHttps(targetUrl)
      if (httpArr && httpArr.filter(x => targetUrl.indexOf(x) > -1).length > 0) {
        if (isHttps) {
          location.href = targetUrl.replace('https://', 'http://')
        }
      }
      if (httpsArr && httpsArr.filter(x => targetUrl.indexOf(x) > -1).length > 0) {
        if (!isHttps) {
          location.href = targetUrl.replace('http://', 'https://')
        }
      }
    },
    dialogVisitorSwitch () {
      this.$refs.dialogVisitor.dialogVisitorSwitch()
    },
    dialogVisitorFastLeave () {
      this.$refs.dialogVisitor.fastLeave()
    },
    openGuestDialog () { // 開啟Plus版的目前訪客
      this.$refs.GuestDialog.openDialog()
    },
    faseActive () {
      this.$refs.FastActive.faseActive()
    },
    updateHeaderframeCount () {
      document.body.style.overflow = null
      if (this.$refs.headerframe) {
        this.$refs.headerframe.upDateCount()
      }
    },
    pushNotify () {
      if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return
      navigator.serviceWorker.addEventListener('message', event => {
        console.log(event)
        const info = event.data
        const title = info.title
        const body = info.msg
        // eslint-disable-next-line eqeqeq
        if (event.data.type == 'msgAlert') {
          this.$alert(body, title, {
            confirmButtonText: '確定',
            callback: action => {}
          })
        }
      })
    },
    initLoginUserInfo () {
      if (!this.loginUserInfo || !this.loginUserInfo.CommunityName || !this.loginUserInfo.AdminName) {
        this.getLoginUserInfo()
      }
    },
    getLoginUserInfo () {
      if (localStorage.getItem('loginUserInfo')) {
        this.loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
      }
    },
    async openManagerQRCode () {
      this.timerSecond = 5 * 60
      await apiHousehold.getManagerIdentifier().then((res) => {
        if (res.status === 200 && res.data && res.data.Data) {
          this.managerQRCodeToken = res.data.Data.Token
        }
      }).catch((err) => {
        console.log(err)
      })
      this.initLoginUserInfo()
      this.isShowManagerQRCode = true
      this.qrcodeTimer = setInterval(() => {
        this.timerSecond--
        if (this.timerSecond < 0) {
          clearInterval(this.qrcodeTimer)
        }
      }, 1000)
    },
    closeManagerQRCodeDialog () {
      clearInterval(this.qrcodeTimer)
    },
    getGeolocation () {
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            position => {
              const { latitude, longitude } = position.coords
              resolve({ latitude, longitude })
            },
            error => {
              switch (error.code) {
              case error.TIMEOUT:
                console.log('geolocation 連線逾時')
                break
              case error.POSITION_UNAVAILABLE:
                console.log('geolocation 無法取得定位')
                break
              case error.PERMISSION_DENIED:
                console.log('geolocation 被拒絕')
                break
              case error.UNKNOWN_ERROR:
                console.log('geolocation 不明的錯誤，請稍候再試')
                break
              }
              reject(error)
            }
          )
        } else if (window.google && google.gears) {
          try {
            const geo = google.gears.factory.create('beta.geolocation')
            geo.getCurrentPosition(
              p => {
                const { latitude, longitude } = p
                resolve({ latitude, longitude })
              },
              err => {
                reject(err)
              },
              { enableHighAccuracy: true, gearsRequestAddress: true }
            )
          } catch (e) {
            console.log('Google Gears 定位失敗請稍候再試')
            reject(e)
          }
        } else {
          reject(new Error('不支援 HTML5 定位和 Google Gears'))
        }
      })
    },
    handleStorage (event) {
      const { key, oldValue, newValue } = event
      if (key !== 'loginUserInfo') return
      const newValueObj = JSON.parse(newValue)
      const oldValueObj = JSON.parse(oldValue)
      if (
        // 一般雙開分頁覆寫登入情境，於登入後觸發
        (!oldValueObj && newValueObj) ||
        // EIP 覆寫登入情境
        (oldValueObj && newValueObj && oldValueObj.Time !== newValueObj.Time)
      ) {
        // 重新整理頁，使資料與狀態保持為最新
        window.location.reload()
        // 移除登記到一半的包裹資料
        window.localStorage.removeItem('despatcher_v2')
      }
    }
  }
}
</script>

<style lang="sass">
@import '@/assets/sass/reset.scss'

/* 如果有某些區塊想還原原本的css，套上.unreset即可*/
@import '@/assets/sass/unreset.scss'
@import '@/assets/sass/main.sass'
</style>

<style lang="sass" scoped>
#app
  #app-header
    min-width: 1140px
    position: sticky
    top: 0
    left: 0
    width: 100%
    z-index: 2000
.dialogText
  margin-bottom: 20px
.qrcode-modal-container
  text-align: center

  #communityName
    padding-top: 10px
    font-size: 24px
    font-weight: bold
  #userName
    padding-block: 20px
    font-size: 24px
    font-weight: bold
  #qrcode
    position: relative
    .reload-btn
      font-size: 40px
      cursor: pointer
      position: absolute
      width: 140px
      height: 140px
      top: 0px
      left: 50%
      transform: translateX(-50%)
      border: unset
      background-color: transparent
  #timer
    margin-top: 20px
    color: $subFontColor
  .qrcode-timeout-hint
    color: $dangerColor
::v-deep .qr-dialog > .el-dialog
  +basicDialog
  border-radius: 8px
  .el-dialog__header
    .dialog-title
      font-size: 25px
      font-weight: bold
      margin-bottom: 5px
</style>
